import { Capacitor } from '@capacitor/core';

export const APP_ORIGIN = Capacitor.isNativePlatform()
  ? 'https://vaquit.app'
  : window.location.origin;
